import WebApp from '@twa-dev/sdk';

import { type Game } from '@/shared/api/game/types';

import { type PlatformEvent } from '../types';

export const makeGameLoadStartEvent = (game: Game): PlatformEvent => ({
  type: 'game_load_start',
  user_properties: {},
  event_properties: {
    name: 'game_load_start',
    game_key: game.key,
    is_adult: game.flags.adult ?? false,
    tg_chat_type: WebApp?.initDataUnsafe?.chat_type ?? 'unknown',
  },
});
